import { Box, TextField, InputAdornment, FormControl } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TimePreview = ({ question }) => {
  const { config } = question;

  return (
    <>
      <Box sx={{ minWidth: "150px" }}>
        <FormControl style={{ width: "150px" }}>
          <TextField
            label="Time"
            value={config?.placeholder || "HH:MM AM/PM"}
            className="custom-text-field"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <FontAwesomeIcon
                    icon={["far", "clock"]}
                    style={{
                      with: "18px",
                      height: "18px",
                      color: "#0000008F",
                    }}
                  />
                </InputAdornment>
              ),
            }}
            variant="standard"
          />
        </FormControl>
      </Box>
    </>
  );
};

export default TimePreview;
